export default __webpack_public_path__ + "static/media/thunder.d1a76051.svg";